<template>
  <div>
    <div class="dovemed-card">
      <div class="user-info-card">
        <div class="user-info-card__image-card">
          <a-avatar
            :style="{ color: ' #ffffff !important', 'background-color': (authUser.user.url ? authUser.user.url : '') ? '' : '#C997C5' }"
            :size="120"
            :src="authUser.user.url"
            class="text-capitalize mr-3"
          >
            {{ authUser.user.firstName ? authUser.user.firstName[0] : authUser.user.display_name ? authUser.user.display_name[0] : authUser.user.first_name[0] }}
          </a-avatar>
        </div>
        <div>
          <p class="font-weight-bold account-settings-name text-capitalize">
            <!-- {{ authUser.user.first_name }} {{ authUser.user.middle_name }}
            {{ authUser.user.last_name }} -->
            {{ authUser.user.role === "doctor" ? authUser.user.first_name + " " + authUser.user.last_name : authUser.user.display_name }}
          </p>
          <!-- <p>{{ authUser.user.display_name }}</p> -->
          <p class="text-capitalize">{{ authUser.user.gender }}</p>
          <p>{{ authUser.user.email }}</p>
        </div>
      </div>
    </div>
    <div class="dovemed-card">
      <p class="font-weight-bold">CLOSE YOUR ACCOUNT</p>
      <p>
        Closing your account will disable your profile and remove your initials from comments you posted. Some information may still be visible to others, such as reviews you have given. Please
        contact DoveMed support team.
      </p>
      <!-- <div class="d-flex justify-content-between">
        <div />
        <button
          class="dovemed-button primary-button font-white ml-4 text-right"
          @click="closeAccount"
          :style="{ background: getPrimaryColor() }"
        >
          CLOSE ACCOUNT
        </button>
      </div> -->
      <div class="d-flex justify-content-between">
        <div />
        <button class="dovemed-button primary-button font-white ml-4 text-right" @click="contactSupportRoute" :style="{ background: getPrimaryColor() }">
          CONTACT SUPPORT
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "AccountSettings",
  data() {
    return { user: null }
  },

  methods: {
    /**
     * Close Account
     */
    closeAccount() {
      UserRepository.closeAccount(this.currentCircle.id)
        .then(res => {
          this.$notification.success({ message: "Success", description: "Account has been succesfully closed." })
          this.logout()
        })
        .catch(err => {
          console.error(err)
        })
    },
    contactSupportRoute() {
      this.$router.push({ name: "ContactUs" })
    },
  },
}
</script>

<style lang="scss">
.account-settings-image {
  height: 120px;
  width: 120px;
  border-radius: 50%;
  margin-right: 10px;
}
.account-settings-name {
  font-size: 20px;
}
.user-info-card {
  display: flex;

  @media screen and (max-width: 581px) {
    display: flex;
    flex-direction: column;

    &__image-card {
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/AccountSettings.vue